// extracted by mini-css-extract-plugin
export var collapsed = "NobleSection-module--collapsed--a790a";
export var emerald = "NobleSection-module--emerald--d5149";
export var evergreen = "NobleSection-module--evergreen--c364e";
export var expanded = "NobleSection-module--expanded--b733d";
export var nobleFrame = "NobleSection-module--noble-frame--44b63";
export var nobleFrameContainer = "NobleSection-module--noble-frame-container--add65";